import ProfileAboutForm from '@/components/Forms/ProfileAboutForm';
import { useGetUserLocation } from '@/query/queries/user/useGetUserLocation';
import { useUpdateProfileAbout } from '@/query/queries/user/useUpdateProfileAbout';
import { useGetMe } from '@/hooks/shared/useGetMe';

const ProfileAboutModal = ({ onClose }) => {
  const { profile } = useGetMe();
  const { data: userLocation } = useGetUserLocation();
  const { mutateAsync: updateProfileAbout } = useUpdateProfileAbout();

  if (!profile) return null;

  const { description, user, social_networks } = profile;

  const onSubmit = async values => {
    const payload = {
      first_name: values.first_name,
      last_name: values.last_name,
      citizenship: values.citizenship,
      citizenship_code: values.citizenship_code,
      facebook: values.facebook || null,
      twitter: values.twitter || null,
      linkedin: values.linkedin || null,
      description: values.description,
    };

    const res = await updateProfileAbout(payload);
    res?.id && onClose();
  };

  return (
    <ProfileAboutForm
      description={description}
      user={{ ...user, ...social_networks }}
      userLocation={userLocation}
      onSubmit={onSubmit}
      onCancel={onClose}
    />
  );
};

export default ProfileAboutModal;
